import { render } from "./ContactBio.vue?vue&type=template&id=28b15167&scoped=true"
import script from "./ContactBio.vue?vue&type=script&lang=js"
export * from "./ContactBio.vue?vue&type=script&lang=js"

import "./ContactBio.vue?vue&type=style&index=0&id=28b15167&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b15167"]])

export default __exports__